import Backbone from 'backbone';
import ko from 'knockout';
import ViewModel from './sharedBudgetModel';
import template from './sharedBudget.pug';
import { setPosition } from './const';

export class SharedBudgetContextualAttributeView extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.sharedBudgetId = targetId;
    this.viewModel = new ViewModel({
      i18n,
    });
  }


  render() {
    const {
      deps,
      sharedBudgetId,
      i18n,
    } = this;

    deps.jsdata.Budget.findAll({
      limit: 1,
      select: ['AssociationCount'],
      where: { Id: { $eq: sharedBudgetId } },
    }).then((response) => {
      if (response.length && response.length > 0) {
        this.viewModel.updateAttribute({
          campaignsCount: response[0].AssociationCount,
        });
        this.$el.html(template({ i18n }));
        ko.applyBindings(this.viewModel, this.el);
        const container = this.$el.children('.contextual-tooltip-container');

        setPosition(container);
      }
    });
    return this;
  }
}
